import { useContext } from "react";
import ModalContext from "./ModalContext";

const useCustomModal = () => {
  return useContext(ModalContext);
};

export default useCustomModal;
